import { Box, Button, Container, Flex } from '@chakra-ui/react'
import NextLink from 'next/link'

type MapStaticProps = {
  lat: number
  lng: number
  linkText: string
  linkUrl: string
}

export const MapStatic = (props: MapStaticProps) => {
  const { lat, lng } = props

  const mobileSize = '768x360@2x'
  const size = '1280x240@2x'
  const token = process.env.NEXT_PUBLIC_MAPBOX_TOKEN
  const style = 'ckua2xf5y507s18odyh5a3n0s'
  const pin = `pin-s+C10D38(${lng},${lat})`
  const zoom = 4

  return (
    <Container maxWidth='6xl' id='map'>
      <Box pos='relative'>
        <picture>
          <source
            media='(min-width: 768px)'
            srcSet={`https://api.mapbox.com/styles/v1/debossgarage/${style}/static/${pin}/${lng},${lat},${zoom},0/${size}?access_token=${token}`}
          />
          <source
            media='(max-width: 767px)'
            srcSet={`https://api.mapbox.com/styles/v1/debossgarage/${style}/static/${pin}/${lng},${lat},${zoom},0/${mobileSize}?access_token=${token}`}
          />
          <img
            alt='Map of location'
            loading='lazy'
            src={`https://api.mapbox.com/styles/v1/debossgarage/${style}/static/${pin}/${lng},${lat},${zoom},0/${size}?access_token=${token}`}
            srcSet={`https://api.mapbox.com/styles/v1/debossgarage/${style}/static/${pin}/${lng},${lat},${zoom},0/${size}?access_token=${token} 2x`}
          />
        </picture>
      </Box>
      {props.linkUrl && props.linkText && (
        <Flex
          backgroundColor='blue.700'
          justifyContent='center'
          py={4}
          width='100%'>
          <NextLink href={props.linkUrl} passHref legacyBehavior>
            <Button as='a' colorScheme='dark' backgroundColor='blue.800'>
              {props.linkText} ›
            </Button>
          </NextLink>
        </Flex>
      )}
    </Container>
  )
}
